import BaseTheme from '../base';

export default {
  ...BaseTheme.FontWeights,
  light: 300,
  regular: 400,
  bold: 500,
  extraBold: 600,
  ultraBold: 700,
  title: 400
};
